export default __webpack_public_path__ + "static/media/char_head_prem_007.ff27fee2.png";